<dashboardnav>
  <cradua-cabinetshelfref
    [fiscalfilelocations]="fiscalfilelocations$ | async"
    [cabinetshelfref]="cabinetshelfref$ | async"
    (changeEmit)="onSubmitCabinetShelfRef($event)"
    (deleteEvent)="onDeleteCabinetShelfRef($event)"
    *ngIf="
      !(isLoadingFiscalFileLocation$ | async) &&
      !(isLoadingCabinetShelfRef$ | async)
    "
  >
  </cradua-cabinetshelfref>

  <mrsoftapps-epims-reference-spinner
    *ngIf="
      (isLoadingFiscalFileLocation$ | async) ||
      (isLoadingCabinetShelfRef$ | async)
    "
  >
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
